import React, { useContext } from "react";
import ErrorBoundary from "components/common/ErrorBoundary";
import AsyncComponent from "components/common/AsyncComponent";
import GestionDrawer from "components/pages/Gestion/GestionDrawer";
import GestionCompetitionLayout from "components/pages/Gestion/GestionCompetitionLayout";
import GestionSubscriptionGate from "components/pages/Gestion/GestionSubscriptionGate";
import GestionAreaGuard from "components/pages/Gestion/GestionAreaGuard";
import UserContext from "context/UserContext";
import { ROUTES } from "constants/routes";

const AsyncPageWithDrawer = AsyncComponent(() => import("components/pages/PageWithDrawer"));

export const GESTION_COMPETITION_BASE = `${ROUTES.ADMIN.GESTION}/:customerId/competitions/:id`;

export function renderGestionCompetitionRoute(Content, options = {}) {
  const { skipLayout = true, contentProps, area } = options;

  const GestionCompetitionRoute = (props) => {
    const userContext = useContext(UserContext);

    return (
      <ErrorBoundary {...props}>
        <AsyncPageWithDrawer
          {...props}
          drawerComponent={<GestionDrawer />}
          enableDrawerCollapse
          content={
            <GestionSubscriptionGate>
              <GestionAreaGuard area={area}>
                {skipLayout ? (
                  <Content userContext={userContext} {...props} {...(contentProps?.(props) ?? {})} />
                ) : (
                  <GestionCompetitionLayout>
                    <Content userContext={userContext} {...props} {...(contentProps?.(props) ?? {})} />
                  </GestionCompetitionLayout>
                )}
              </GestionAreaGuard>
            </GestionSubscriptionGate>
          }
        />
      </ErrorBoundary>
    );
  };

  return GestionCompetitionRoute;
}
